import CalendarLayoutThirdStep from "./ThirdStep/Calendar";
import AutoScheduleStep from "./AutoSchedule/AutoScheduleStep";
import { useTranslation } from "react-i18next";

const ThirdStepSchedule = ({ prev, isEdit, dataForm, onChangeDataForm }) => {
  const { t } = useTranslation();

  if (dataForm.modeForm === "auto") {
    return (
      <AutoScheduleStep
        prev={prev}
        dataForm={dataForm}
        onChangeDataForm={onChangeDataForm}
      />
    );
  }

  return (
    <>
      <div>
        <div className="text-center text-xl">
          {t("meeting_schedule.title_third_step")}
        </div>
        <div className="mt-3 flex flex-wrap justify-center gap-2"></div>
      </div>

      <CalendarLayoutThirdStep
        prev={prev}
        data={dataForm}
        isEdit={isEdit}
        onChangeDataForm={onChangeDataForm}
      />
    </>
  );
};

export default ThirdStepSchedule;
